export type WorkspacePanelContext = 'board' | 'workspace';

export function getWorkspacePanelLabel(panelContext: WorkspacePanelContext, action: 'collapse' | 'expand'): string {
  return action === 'collapse' ? `Collapse ${panelContext} panel` : `Expand ${panelContext} panel`;
}
